import React, { useState } from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { IconButton, Modal, Tooltip, Typography } from 'ui-kit';
import { useStoreIntegrations } from 'api/store_sdk';
import Stack from 'ui-kit/Stack';
import { getIntegrationLogo } from 'components/Partners/utils';
import dayjs from 'dayjs';

import './styles.scss';

export interface IStoreIntegrationsButtonModal {
  storeId: number;
}

const StoreIntegrationsButtonModal = ({ storeId }: IStoreIntegrationsButtonModal) => {
  const [isOpen, setIsOpen] = useState(false);

  const { data: storeIntegrations } = useStoreIntegrations({
    storeId,
    enabled: isOpen,
  });

  return (
    <>
      <Tooltip title="View integrations">
        <IconButton color="primary" variant="text" onClick={() => setIsOpen(true)}>
          <LinkOutlined />
        </IconButton>
      </Tooltip>
      <Modal
        className="StoreIntegrations-modal"
        visible={isOpen}
        onCancel={() => setIsOpen(false)}
        footer={null}
        destroyOnClose
        title="Connected Integrations"
        width={620}
      >
        <Stack style={{ width: '100%' }} gap="20px" flexDirection="column">
          {storeIntegrations?.map(({ platform, platform_id, is_imported_source, date_created }) => (
            <Stack
              key={platform_id}
              className="StoreIntegrations-modal__integration"
              alignItems="center"
              justifyContent="space-between"
              gap="20px"
            >
              <img src={getIntegrationLogo({ company: platform })} alt="logo" height="30px" />
              <Typography variant="body2">
                Connected: {dayjs(date_created).format('MMM D, YYYY')}
              </Typography>
              <Typography variant="body2">
                {is_imported_source ? 'Is imported' : 'Is synced'}
              </Typography>
            </Stack>
          ))}
        </Stack>
      </Modal>
    </>
  );
};

export default StoreIntegrationsButtonModal;
